// Keeps one broken page from blanking the whole app: the sidebar stays, and the page shows the
// error with a way back. Reset by giving it a new `key` (the shell uses the page path).
import { Component, type ReactNode } from "react";
import { Button } from "./controls.tsx";

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 p-10 text-center">
        <div className="text-sm font-medium">This page hit a problem</div>
        <code className="max-w-xl rounded-md bg-surface-2 px-3 py-2 text-[12px] text-muted">{this.state.error.message}</code>
        <Button onClick={() => location.reload()}>Reload</Button>
      </div>
    );
  }
}
